import { BASE_URL } from './Url';
/**
 * Travas dos recursos de depuração do SDK.
 *
 * Recursos, ambos ativados por query param e SEMPRE bloqueados em produção:
 *
 *  - `?livenessDebug=1` -> painel de diagnóstico na tela (útil no celular, sem cabo).
 *  - `?livenessMock=1`  -> simulação local do desafio, para validar a UI sem backend.
 *
 * Por que a trava de produção importa: a simulação conduz o desafio no cliente.
 * Se ela pudesse rodar em produção e concluir o step, viraria um caminho para
 * burlar a prova de vida. Por isso, além da trava, o modo simulado NUNCA chama
 * saveStep — a aprovação continua sendo exclusivamente do servidor.
 *
 * Sobre a persistência: o SDK navega com `navigate('/form', { state })`, que
 * DESCARTA a query string. Sem persistir, a flag morreria antes de chegar ao
 * step de liveness. Por isso capturamos a query no carregamento inicial da
 * página e guardamos em sessionStorage (escopo da aba, sem vazar entre sessões).
 */
/** URL da API de produção. Qualquer outra base é considerada ambiente de teste. */
var PRODUCTION_API = 'https://backoffice.idcerberus.com/api';
var STORAGE_PREFIX = 'sdkDebug:';
/** Flags reconhecidas. Manter explícito evita persistir query arbitrária. */
var KNOWN_FLAGS = ['livenessDebug', 'livenessMock'];
export function isProductionApi() {
    var base = (BASE_URL || '').trim().replace(/\/+$/, '');
    return base === PRODUCTION_API.replace(/\/+$/, '');
}
function readFlagFromSearch(search, flag) {
    try {
        var value = new URLSearchParams(search).get(flag);
        return value === '1' || value === 'true';
    }
    catch (_a) {
        return false;
    }
}
function readFlagFromStorage(flag) {
    try {
        return window.sessionStorage.getItem(STORAGE_PREFIX + flag) === '1';
    }
    catch (_a) {
        // sessionStorage pode estar indisponível (modo privado/iframe restrito).
        return false;
    }
}
function persistFlag(flag) {
    try {
        window.sessionStorage.setItem(STORAGE_PREFIX + flag, '1');
    }
    catch (_a) {
        // Sem storage, a flag só vale enquanto a query estiver na URL.
    }
}
/**
 * Captura as flags presentes na URL de carregamento. Chamado no import deste
 * módulo, que acontece no bootstrap do bundle — portanto antes de qualquer
 * navegação do React Router descartar a query string.
 */
function captureFlagsFromInitialUrl() {
    var _a;
    if (typeof window === 'undefined' || isProductionApi()) {
        return;
    }
    var search = ((_a = window.location) === null || _a === void 0 ? void 0 : _a.search) || '';
    if (!search) {
        return;
    }
    KNOWN_FLAGS.forEach(function (flag) {
        if (readFlagFromSearch(search, flag)) {
            persistFlag(flag);
        }
    });
}
captureFlagsFromInitialUrl();
/**
 * Indica se a flag de depuração está ativa, considerando a query atual e a
 * captura feita no carregamento inicial. Em produção retorna sempre false.
 *
 * @param search query string atual (ex.: location.search do React Router).
 */
export function isDebugFlagEnabled(search, flag) {
    if (isProductionApi()) {
        return false;
    }
    return readFlagFromSearch(search, flag) || readFlagFromStorage(flag);
}
